import React, {Component} from 'react'
import PropTypes from 'prop-types'

import ChartCanvas from '../ChartCanvas'
import CrossHairCursor from '../CrossHairCursor'

import {discontinuousTimeScaleProvider} from 'react-stockcharts/lib/scale'

import {fitWidth} from 'react-stockcharts/lib/helper'
import {last} from 'react-stockcharts/lib/utils'

import {getExtents} from '../functions'

import {getPnlChart} from '../parts/Pnl'
import {getPriceChart} from '../parts/Price'
import {getIndicatorsCharts} from '../parts/Indicators'

class SingleTicker extends Component {
  state = {
    suffix: 1
  }
  handleReset = () => {
    this.setState({
      suffix: this.state.suffix + 1
    })
  }
  getTextWidth = (text) => {
    var canvas = this.canvas || (this.canvas = document.createElement('canvas'))
    var context = canvas.getContext('2d')
    context.font = '12px Helvetica, Arial, sans-serif'
    var metrics = context.measureText(text)
    return metrics.width
  }
  render() {
    const {type, data: initialData, width, ratio, timeFormat, indicatorsList} = this.props
    const mouseCoordinateWidth = timeFormat.length > 8 ? 120 : 80
    const margin = { left: 70, right: 50, top: 20, bottom: 20 }

    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(d =>
      new Date(new Date(d.ts).getTime() + new Date(d.ts).getTimezoneOffset()*60000 - 4*60*60000)
    )

    const {
      data,
      xScale,
      xAccessor,
      displayXAccessor,
    } = xScaleProvider(initialData)

    const start = xAccessor(last(data))
    const end = xAccessor(data[0])
    const xExtents = [start, end]

    const filteredIndicators = data.filter(row => !!row.indicators)
    const indicatorsCount = Object.keys(indicatorsList).length

    let totalHeight = 0

    if (!this.props.pnlFailed) {
      totalHeight += 290
    }
    if (!this.props.priceFailed) {
      totalHeight += 390
    }
    if (!this.props.indicatorsFailed) {
      if (this.props.priceFailed) {
        totalHeight += indicatorsCount * 250 + 40
      } else {
        totalHeight += indicatorsCount * 250
      }
    }

    return (
      <ChartCanvas
        seriesName={`single-ticker-${this.state.suffix}`}
        height={totalHeight}
        ratio={ratio}
        width={width}
        margin={margin}
        type={type}
        panEvent={true}
        zoomEvent={false}
        data={data}
        xScale={xScale}
        xAccessor={xAccessor}
        displayXAccessor={displayXAccessor}
        xExtents={xExtents}
        clamp={true}
      >

        {!this.props.priceFailed && getPriceChart(
          width,
          margin,
          getExtents(data, ['high', 'low']),
          this.props.priceTicker,
          this.handleReset,
          timeFormat,
          mouseCoordinateWidth
        )}

        {!this.props.pnlFailed &&
          getPnlChart(width, margin, getExtents(data, ['pnl']), this.props.priceFailed ? [0,0] : [0,390], this.handleReset, timeFormat, mouseCoordinateWidth, this.props.indicatorsFailed)
        }

        {!this.props.indicatorsFailed && getIndicatorsCharts(
          filteredIndicators,
          this.props.consts,
          this.props.units,
          this.props.interpolation,
          this.props.pnlFailed ? 0 : 290,
          this.props.priceFailed ? 0 : 350,
          width,
          margin,
          this.getTextWidth,
          this.handleReset,
          timeFormat,
          mouseCoordinateWidth,
          indicatorsList
        )}

        <CrossHairCursor/>
      </ChartCanvas>

    )
  }
}

SingleTicker.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['svg', 'hybrid']).isRequired,
}

SingleTicker.defaultProps = {
  type: 'svg',
}
SingleTicker = fitWidth(SingleTicker)

export default SingleTicker
